module.exports = __webpack_public_path__ + "static/media/05.adbb2558.gif";